import * as ConfigUrlUtils from './common/utils/ConfigUrlUtils'
import * as EnvUtils from './common/utils/EnvUtils'

//const DEFAULT_CONFIG = "-staging";        // 1.4.0 Live
  const DEFAULT_CONFIG = "-qa-latest";      // 1.4.0 QA
//const DEFAULT_CONFIG = "-devci-latest";   // 1.4.0 DevCI
//const DEFAULT_CONFIG = "";                // 1.3.1 Live
//const DEFAULT_CONFIG = "-qa-released";    // 1.3.1 QA
//const DEFAULT_CONFIG = "-devci-released"; // 1.3.1 DevCI

export const APP_NAME = 'pdm';

export function CurrentCRA() {
//return EnvUtils.GetUrlDerivedOrEnv(ConfigUrlUtils.GetAppCRA(window.location.origin, APP_NAME), undefined, `https://localhost:44385`);
  return EnvUtils.GetUrlDerivedOrEnv(ConfigUrlUtils.GetAppCRA(window.location.origin, APP_NAME), undefined, `https://cra${DEFAULT_CONFIG}.magstimconnect.net`);
}

export function CurrentReportingAPI() {
//return EnvUtils.GetUrlDerivedOrEnv(ConfigUrlUtils.GetApiReporting(window.location.origin, APP_NAME), undefined, `https://localhost:44331/api`);
  return EnvUtils.GetUrlDerivedOrEnv(ConfigUrlUtils.GetApiReporting(window.location.origin, APP_NAME), undefined, `https://api-reporting${DEFAULT_CONFIG}.magstimconnect.net/api`);
}

export function CurrentAPI() {
  return CurrentPdmAPI();
}

export function CurrentPdmAPI() {
//return EnvUtils.GetUrlDerivedOrEnv(ConfigUrlUtils.GetApiPdm(window.location.origin, APP_NAME), undefined, `https://localhost:44322/api`);
  return EnvUtils.GetUrlDerivedOrEnv(ConfigUrlUtils.GetApiPdm(window.location.origin, APP_NAME), undefined, `https://api-pdm${DEFAULT_CONFIG}.magstimconnect.net/api`);
}

export function CurrentAnalyticsAPI() {
//return EnvUtils.GetUrlDerivedOrEnv(ConfigUrlUtils.GetApiAnalytics(window.location.origin, APP_NAME), undefined, `https://localhost:44394/api`);
  return EnvUtils.GetUrlDerivedOrEnv(ConfigUrlUtils.GetApiAnalytics(window.location.origin, APP_NAME), undefined, `https://api-analytics${DEFAULT_CONFIG}.magstimconnect.net/api`);
}

export function isPDA() {

    switch(localStorage.getItem('Configuration')) {
        case 'Desktop':
            return false;
        case 'Web':
            return true;
        default:
            return false;
      }
}

export  default isPDA;

export const MAX_NUMBER_OF_REPORTS = 10;